<template>
  <div class="content self_content" style="background-color: #ebedf0;">
    <!--  -->
    <headNav color="#56AC9A" :back="true" :title="window_c['Reservation details']"/>
    <iframe :style="'height:' + window_.wh + 'px;'" :src="iframeSrc"></iframe>
  </div>
</template>

<script>
  import headNav from '@/components/headNav';
  import util from '@/js/util.js';
  import lang_ from '@/js/locales';

  export default {
    data() {
      return {
        window_c: {
          'Reservation details': '餐檯預定'
        },
        window_: {
          wh: 0
        },
        iframeSrc: ''
      };
    },
    created() {
      util.selfSetIcon(); // 設置logo
      util.getBrand(this);
    },
    mounted() {
      this.init_lang();
      this.window_.wh = window.innerHeight - 46;
      var foodStoryReservationUrl = sessionStorage.foodStoryReservationUrl;
      this.iframeSrc = foodStoryReservationUrl;
    },
    methods: {
      init_lang() {
        var window_c = this.window_c;
        window_c['Reservation details'] = lang_.t('Reservation details');
      }
    },

    components: {
      headNav
    }
  };
</script>

<style scoped>
  .self_content {
    height: 100%;
  }

  iframe {
    width: 100%;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/brand/reservation_detail.vue